import gql from 'graphql-tag';
export const touchDocumentAssistantPrompt = gql `
  mutation TouchDocumentAssistantPrompt($promptId: UUID!) {
    touchDocumentAssistantPrompt(id: $promptId) {
      id
      usedAt
    }
  }
`;
